import { Component, Input, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { SignupModalService } from '../../services/signup-modal.service';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive, ButtonModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  @Input() textColor: string = 'rgba(255,255,255,0.85)';

  private readonly router = inject(Router);
  private readonly signupModal = inject(SignupModalService);

  discordLink   = 'https://discord.gg/kPmW3m4drD';
  facebookLink  = 'https://www.facebook.com/GetNerdApp/';
  xLink         = 'https://x.com/nerd_app';
  instagramLink = 'https://www.instagram.com/getnerd.app/';
  linkedinLink  = 'https://www.linkedin.com/company/thenerdapp/';
  iosLink       = 'https://apps.apple.com/us/app/nerd/id6769080414';
  androidLink   = 'https://play.google.com/store/apps/details?id=com.nerdapplications.app';
  isMenuOpen    = false;

  get hideNavbar(): boolean {
    const path = this.router.url.split(/[?#]/)[0];
    return path === '/' || path === '/home';
  }

  get isExploreSection(): boolean {
    const path = this.router.url.split(/[?#]/)[0];
    return ['/explore', '/decks', '/topics', '/leaderboards'].includes(path);
  }

  openDiscord():   void { window.open(this.discordLink,   '_blank'); }
  openFacebook():  void { window.open(this.facebookLink,  '_blank'); }
  openX():         void { window.open(this.xLink,         '_blank'); }
  openInstagram(): void { window.open(this.instagramLink, '_blank'); }
  openLinkedIn():  void { window.open(this.linkedinLink,  '_blank'); }

  toggleMenu(): void { this.isMenuOpen = !this.isMenuOpen; }
  closeMenu():  void { this.isMenuOpen = false; }

  openSignupModal(): void { this.signupModal.openModal(); this.closeMenu(); }
}
